import { render, staticRenderFns } from "./UserPersonalCenter.vue?vue&type=template&id=1f054be6&scoped=true"
import script from "./UserPersonalCenter.vue?vue&type=script&lang=js"
export * from "./UserPersonalCenter.vue?vue&type=script&lang=js"
import style0 from "./UserPersonalCenter.vue?vue&type=style&index=0&id=1f054be6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f054be6",
  null
  
)

export default component.exports